import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import DefRoutes from "../../routes/routes.json";
import t from "../../i18n/i18n";
import initPage from "../../utils/initPage";
import useApi from "../../services/api";

import Template from "../../template/template";
import Header from "./header/header";

function Frequent() {
  initPage({ title: "" });

  const { ApiGetFaqFrequent } = useApi();
  const [frequent, setFrequent] = useState([]);

  async function getFrequent() {
    const { data } = await ApiGetFaqFrequent();

    setFrequent(data);
  }

  useEffect(() => {
    getFrequent();
  }, []);

  return (
    <Template>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="support-warp">
              <div className="support-warp-main">
                <Header />

                <div className="support-content">
                  {/* <div className="support-search">
                    <h4>{t("Support.Search")}</h4>
                    <div className="input-text icon-search">
                      <input type="text" value="" pattern="" />
                    </div>
                  </div> */}

                  <div className="intro">
                    <h2>{t("Support.Menu.Frenquently")}</h2>
                    {frequent.map((F) => {
                      return (
                        <>
                          <h4>{F.title}</h4>
                          <p>{F.response}</p>
                        </>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
}

export default Frequent;
